export default {
      id: "user-centric-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#user-centric",
      toString: function () {
        return this.url;
      }
    }